import { render, staticRenderFns } from "./AdWindow.vue?vue&type=template&id=59f56fd4&"
import script from "./AdWindow.vue?vue&type=script&lang=js&"
export * from "./AdWindow.vue?vue&type=script&lang=js&"
import style0 from "./AdWindow.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports